import { sha256 } from "js-sha256";
import { normalizeAddress } from "@/lib/geo/normalize";

/**
 * Deterministic per-row key. Reuses M2's `normalizeAddress` so the derivation
 * cannot drift from the geo layer (R-7): two address strings that normalize
 * identically get the same row_key, which is also the same address M2 caches
 * on — so re-maps reuse cached coords and only changed rows re-geocode
 * (acceptance #8). Isomorphic (js-sha256, not node:crypto) so it runs the same
 * in the browser (where the DTO is assembled) and on the server.
 */
export function rowKeyForAddress(query: string): string {
  return sha256(`addr:${normalizeAddress(query)}`);
}

/**
 * Coordinate-mode row key. Pre-supplied coords pass through M2 with no geocode,
 * so the key is derived from the rounded pair (6dp ≈ 0.1m, well past address
 * precision) to keep it stable against float noise.
 */
export function rowKeyForCoord(lat: number, lng: number): string {
  return sha256(`coord:${lat.toFixed(6)},${lng.toFixed(6)}`);
}
